import { useTheme, useMediaQuery } from '@mui/material';
import DeskStudioLandingPageDesktopRev from './DeskStudioLandingPageDesktopRev';
import DeskStudioLandingPageMobileRev from './DeskStudioLandingPageMobileRev';

export default function DeskStudioLandingPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DeskStudioLandingPageMobileRev />
    : <DeskStudioLandingPageDesktopRev />;
}